import { j as l } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as r } from "react";
import { I as i } from "../../../../IconBase-CxZyIWw2.js";
const s = r((e, o) => /* @__PURE__ */ l.jsx(
  i,
  {
    ref: o,
    ...e,
    image: (a) => /* @__PURE__ */ l.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...a,
        children: /* @__PURE__ */ l.jsx(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M10.253 13.789A5.5 5.5 0 1 1 2.475 6.01l4.596-4.596a4 4 0 1 1 5.657 5.657l-4.596 4.596a2.5 2.5 0 0 1-3.536-3.535L8.58 4.15l1.414 1.414L6.01 9.546a.5.5 0 0 0 .707.707l4.596-4.596a2 2 0 1 0-2.828-2.829L3.889 7.425a3.5 3.5 0 0 0 4.95 4.95l3.982-3.983 1.415 1.414z",
            clipRule: "evenodd"
          }
        )
      }
    )
  }
));
s.displayName = "PaperclipIcon";
export {
  s as PaperclipIcon,
  s as default
};
//# sourceMappingURL=index.js.map
